import './DeleteRecordingsOptions.scss';
import Asset from '../../requests/apa/Asset';
import { ColoredButton } from '../../packages/components';
import { Grid, Column, Row, cls, Button } from '../../packages/components';
import React, { Component } from 'react';
import { showModal } from '../../actions/modal';
import Translator from '../../requests/apa/Translator';
import { connect } from 'react-redux';
import Device from '../../devices/device';

class DeleteRecordingsOptions extends Component {

    constructor(props = {}) {
        super(props);
        this.data = props.data;
        this.onSuccess = props.onSuccess || null;
        this.onCancel = props.onCancel || null;

        this.handleKey = this.handleKey.bind(this);

        this.keys = Device.getDevice().getKeys();
    }

    sendDimension = () => {
    }

    sendMetric = action => {
        this.sendDimension();
    }

    componentDidMount() {
        window.SpatialNavigation.focus('#delete-button-modal');
        this.addListeners();
    }

    componentWillUnmount = () => {
        this.removeListeners();
    }

    addListeners = () => {
        document.addEventListener('keydown', this.handleKey, true);
    }
    removeListeners = () => {
        document.removeEventListener('keydown', this.handleKey, true);
    }

    handleKey = (e) => {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        switch (currentKey) {
            case 'YELLOW':
                e.preventDefault();
                e.stopPropagation();
                this.onCancel();
                break;
            default:
        }
    }

    onSuccess(e) {
        this.onSuccess && this.onSuccess(e);
    }

    onCancel() {
        this.onCancel && this.onCancel(e);
    }

    render() {
        let key = 1;
        return (
            <Grid className={cls(`aaf-main-modal-delete-tv-channel`)}>
                <Row className={cls(`aaf-main-modal-delete-row`)}>
                    <Column lg={3}>
                      &nbsp;
                    </Column>

                    <Column lg={6}>
                        <div className={cls(`aaf-main-modal-delete-center-wrapper`)}>

                            {/* Main title */}
                            <div className={cls(`aaf-main-modal-delete-main-title`)}>
                                {Translator.get('contentToDelete_modal_titleRecordingPresentEvent_label', 'Eliminar Grabación')}
                            </div>

                            {/* Imagen del contenido */}
                            <div
                                className={cls(`aaf-main-modal-delete-image`)}
                                style={{ backgroundImage: `url(${this.props.data.cover})` }}
                            />

                            {/* Estas seguro de....? */}
                            <div className={cls(`aaf-main-modal-delete-secondary-title`)}>
                                {Translator.get('contentToDelete_modal_descriptionBegin_label', '¿Seguro que deseas eliminar')}
                                &nbsp;{this.props.data.title}
                                {Translator.get('contentToDelete_modal_descriptionEnd_label', '?')}
                            </div>

                            {/* Botones */}
                            <div className={cls(`aaf-main-modal-delete-button1`)}>
                                <div className={cls(`aaf-main-modal-delete-wrapper-button`)}>
                                    <div className={cls(`aaf-main-modal-delete-button1`)}>
                                        <Button
                                            id="delete-button-modal"
                                            type="button"
                                            variant={'dark'}
                                            key={key++}
                                            onClick={this.onSuccess}
                                            className={'focusable btn-modal-bookmark'}
                                        >
                                            {Translator.get('contentToDelete_modal_option_button_deleteRecord', 'Eliminar')}{' '}
                                        </Button>
                                    </div>
                                    <div className={cls(`aaf-main-modal-delete-button2`)}>
                                        <Button
                                            type="button"
                                            variant={'dark'}
                                            key={key++}
                                            onClick={this.onCancel}
                                            className={'focusable btn-modal-bookmark'}
                                        >
                                            {Translator.get('contentToDelete_modal_option_button_cancel', 'Cancelar')}{' '}
                                        </Button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </Column>

                    <Column lg={3}>
                      <div className={cls(`aaf-main-modal-delete-colored-button`)}>
                        <ColoredButton
                          color={'yellow'}
                          className={cls(`aaf-main-modal-delete-recordings-options-color`, `focusable`)}
                          onClick={this.onCancel}
                          imgSrc={Asset.get('top_head_option_back', '')}>
                          {Translator.get('contentToCancel_modal_option_button_cancel', 'REGRESAR')}
                        </ColoredButton>
                      </div>
                    </Column>

                </Row>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => ({}
    /*
    {
        // Se deja por si hay que agregar last touch a algun lado
        user: state.user,
    } */
);

const mapDispatchToProps = {
    showModal,
    // Se dejan por si se ocupan
    // setMetricsEvent
}

export default connect(mapStateToProps, mapDispatchToProps)(DeleteRecordingsOptions);



// WEBPACK FOOTER //
// ./src/components/DeleteRecordingsOptions/index.jsx